import { useWidgetMinimizedViewSettings } from '@widgets/messenger/compositions/useWidgetMinimizedViewSettings'
import { ref } from '@/composition/vue/compositionApi'

export const useWidgetEyeCatcher = () => {
  const minimizedViewSettings = useWidgetMinimizedViewSettings()

  const isVisible = ref(false)
  let timer: ReturnType<typeof setTimeout>

  const run = () => {
    const { eyeCatcherDelay } = minimizedViewSettings.value

    timer = setTimeout(() => {
      isVisible.value = true
    }, eyeCatcherDelay * 1000)
  }

  const close = () => {
    if (timer) {
      clearTimeout(timer)
    }
    isVisible.value = false
  }

  return {
    isVisible,
    run,
    close,
  }
}
